import React from "react";
import { t } from "ttag";

import {
    MediaPullQuoteSlide,
    MediaPullQuoteCarouselBlock as Value,
} from "@reactivated";

import { notEmptyOrBlank } from "@thelabnyc/thelabui/src/utils/functional";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ListCarousel } from "../Carousel/ListCarousel";
import { MediaChooserBlock } from "../MediaChooserBlock";
import { RichText } from "../RichText";

import styles from "./index.module.scss";

const Slide = (props: MediaPullQuoteSlide) => (
    <figure className={styles.pullQuoteSlide}>
        <blockquote className={styles.quote}>{props.quote}</blockquote>
        <figcaption className={styles.citation}>
            <p>{props.citation_1}</p>
            {props.citation_2 && props.citation_2.length > 0 && (
                <p>{props.citation_2}</p>
            )}
        </figcaption>
    </figure>
);

const slidesVisible = 1.25;
const slidesVisibleMobile = 1;

interface CustomCss extends React.CSSProperties {
    "--slides-visible-desktop": number;
    "--slides-visible-mobile": number;
}

export const MediaPullQuoteCarouselBlock = ({
    value: { block_name, content, media, slides, theme },
}: {
    value: Value;
}) => {
    if (!slides) return <></>;

    return (
        <section
            className={styles[theme ?? "match"]}
            style={
                {
                    "--slides-visible-desktop": slidesVisible,
                    "--slides-visible-mobile": slidesVisibleMobile,
                } as CustomCss
            }
        >
            <div className={styles.header}>
                {content && <RichText value={content} />}
            </div>
            <div className={styles.inner}>
                {media && media.length > 0 ? (
                    <MediaChooserBlock
                        wrapperAttrs={{ className: styles.mediaWrapper }}
                        value={media}
                        type="background"
                    />
                ) : null}
                <ListCarousel
                    label={block_name || t`Carousel`}
                    className={styles.ul}
                    navigationProps={{ className: styles.carouselNav }}
                    wrapperAttrs={{ className: styles.carousel }}
                    listItemAttrs={{
                        className: concatClassNames([
                            styles.listItem,
                            slides.length === 1
                                ? styles.singleListItem
                                : undefined,
                        ]),
                    }}
                    dotsClassName={styles.dots}
                >
                    {slides.filter(notEmptyOrBlank).map((slide) => (
                        <Slide {...slide.value} key={slide.id} />
                    ))}
                </ListCarousel>
            </div>
        </section>
    );
};
